import { IonSkeletonText, IonSlides } from "@ionic/react";
import React from "react";

const sliderConfig = {
  spaceBetween: 16,
  breakpoints: {
    1024: {
      slidesPerView: 7,
      slidesPerGroup: 7,
    },
    720: {
      slidesPerView: 6,
      slidesPerGroup: 6,
    },
    768: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
    680: {
      slidesPerView: 4.5,
      slidesPerGroup: 4.5,
    },
    640: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    480: {
      slidesPerView: 4.5,
      slidesPerGroup: 4.5,
    },
    320: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
};

const categoriesSkeleton = [...Array(10).keys()];

const CategoriesSkeleton = () => {
  return (
    <div className="flex flex-col h-[10.875rem] gap-1 ">
      <IonSkeletonText className="w-[7.5rem] h-5 rounded-lg m-0" animated />
      <IonSlides {...sliderConfig}>
        <div className="flex justify-center items-center gap-1  ">
          {categoriesSkeleton.map((skelet) => {
            return <IonSkeletonText key={skelet} className="w-[7.5rem] h-[9.375rem] rounded-lg m-0" animated />;
          })}
        </div>
      </IonSlides>
    </div>
  );
};

export default CategoriesSkeleton;
